import { render, staticRenderFns } from "./UploadImageInput.vue?vue&type=template&id=32036d40&scoped=true"
import script from "./UploadImageInput.vue?vue&type=script&lang=js"
export * from "./UploadImageInput.vue?vue&type=script&lang=js"
import style0 from "./UploadImageInput.vue?vue&type=style&index=0&id=32036d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32036d40",
  null
  
)

export default component.exports